const storedLgpath = localStorage.getItem("lgpath");
// const storedLgpath = urlHome ? decodeURIComponent(urlHome) : null;

// const baseUrl = "http://localhost:3008/admin";
// const commonUrl = "http://localhost:3008/";
// const homeUrl = "http://localhost:5173/";
// const redirectUrl = storedLgpath
//   ? `http://localhost:5173/login?ur_d=${storedLgpath}`
//   : "http://localhost:5173/login";

// const baseUrl = "https://productionbackend.wizzo.in/admin";
// const commonUrl = "https://productionbackend.wizzo.in/";
// const homeUrl = 'https://productioncloud.wizzo.in/';
// const redirectUrl = storedLgpath
//   ? `https://productioncloud.wizzo.in/login?ur_d=${storedLgpath}`
//   : "https://productioncloud.wizzo.in/login";

//  const baseUrl = "https://server.wizzo.in/admin";
// const commonUrl = "https://server.wizzo.in/";
//  const homeUrl = "https://one.wizzo.in/";
// const redirectUrl = storedLgpath
//   ? `https://one.wizzo.in/login?ur_d=${storedLgpath}`
//   : "https://one.wizzo.in/login";

const baseUrl = "https://backend.live.azure.wizzo.in/admin";
const commonUrl = "https://backend.live.azure.wizzo.in/";
const homeUrl = "https://cloud.live.azure.wizzo.in/";
const redirectUrl = storedLgpath
  ? `https://cloud.live.azure.wizzo.in/login?ur_d=${storedLgpath}`
  : "https://cloud.live.azure.wizzo.in/";

// const baseUrl = "https://backend.utho.wizzo.in/admin";
// const commonUrl = "https://backend.utho.wizzo.in/";
// const homeUrl = "https://cloud.utho.wizzo.in/";
// const redirectUrl = storedLgpath
//   ? `https://cloud.utho.wizzo.in/login?ur_d=${storedLgpath}`
//   : "https://cloud.utho.wizzo.in/";

// const baseUrl = "https://backend.wps.wizzo.in/admin";
// const commonUrl = "https://backend.wps.wizzo.in/";
// const homeUrl = "https://cloud.wps.wizzo.in/";
// const redirectUrl = storedLgpath
//   ? `https://cloud.wps.wizzo.in/login?ur_d=${storedLgpath}`
//   : "https://cloud.wps.wizzo.in/";

// // eslint-disable-next-line import/no-unused-modules


 export { baseUrl, homeUrl, redirectUrl, commonUrl };

// admin-console.utho
